import { useEffect, useState } from 'react'
import { Alert, Checkbox, FormControlLabel, Paper, Stack, Switch, Typography } from '@mui/material'
import { lerPreferenciaAlertas, salvarPreferenciaAlertas, type PreferenciaAlertas } from '../api/alertas'
import { useAuth } from '../state/AuthContext'

/**
 * A escolha de cada pessoa: receber os alertas por e-mail, num resumo por dia, logo depois que
 * eles são gerados (6h30). Só das marcas que ela vê; dia sem alerta não tem e-mail.
 */
export function AlertasPorEmail() {
  const { user } = useAuth()
  const [p, setP] = useState<PreferenciaAlertas | null>(null)
  const [salvando, setSalvando] = useState(false)
  const [erro, setErro] = useState<string | null>(null)

  useEffect(() => {
    lerPreferenciaAlertas()
      .then(setP)
      .catch((e: Error) => setErro(e.message))
  }, [])

  const salvar = async (nova: PreferenciaAlertas) => {
    if (!user) return
    const antes = p
    setP(nova)
    setSalvando(true)
    setErro(null)
    try {
      await salvarPreferenciaAlertas(user.id, nova)
    } catch (e) {
      setP(antes)
      setErro((e as Error).message)
    } finally {
      setSalvando(false)
    }
  }

  return (
    <Paper variant="outlined" sx={{ px: 2, py: 1.25 }}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 0.5, sm: 2 }} alignItems={{ sm: 'center' }} useFlexGap flexWrap="wrap">
        <FormControlLabel
          control={<Switch checked={!!p?.porEmail} disabled={!p || salvando} onChange={(e) => salvar({ ...p!, porEmail: e.target.checked })} />}
          label="Receber por e-mail"
        />
        <FormControlLabel
          control={<Checkbox checked={!!p?.soCriticos} disabled={!p?.porEmail || salvando} onChange={(e) => salvar({ ...p!, soCriticos: e.target.checked })} />}
          label="Só os críticos"
        />
        <Typography variant="caption" color="text.secondary" sx={{ flex: 1, minWidth: 220 }}>
          Um e-mail por dia, às 6h30, com os alertas das marcas que você vê{user?.email ? `, para ${user.email}` : ''}. Dia sem alerta, sem e-mail.
        </Typography>
      </Stack>
      {erro ? (
        <Alert severity="error" sx={{ mt: 1 }} onClose={() => setErro(null)}>
          {erro}
        </Alert>
      ) : null}
    </Paper>
  )
}
